import { render } from "./userClaim.vue?vue&type=template&id=15d0277c&scoped=true"
import script from "./userClaim.vue?vue&type=script&lang=js"
export * from "./userClaim.vue?vue&type=script&lang=js"

import "./userClaim.vue?vue&type=style&index=0&id=15d0277c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d0277c"]])

export default __exports__